module.exports = __webpack_public_path__ + "img/rank.13c848e.png";